import React, { useEffect, useState } from "react";
import {
  Link,
  Navigate,
  Route,
  BrowserRouter as Router,
  Routes,
} from "react-router-dom";
import AuthRoute from "components/AuthRoute";
import DashboardPage from "./pages/DashboardPage/DashboardPage";
import LoginPage from "./pages/LoginPage/LoginPage";
import ResetPassword from "pages/ResetPassword/ResetPassword";
import NewPassword from "pages/ResetPassword/NewPassword";
import TwoFa from "pages/TwoFa/TwoFa";
import Layout from "components/Layout";
import Reports from "pages/Reports/Reports";
import Werke from "pages/WerkePage/WerkePage";
import Instandhaltung from "pages/InstandhaltungPage/Instandhaltung";
import Backup from "pages/BackupPage/Backup";
import Wartungskalender from "pages/WartungskalenderPage/Wartungskalender";
import ScopeHeader from "components/ScopeHeader";
import i18n from "i18n/i18n";
import NewReport from "pages/Reports/NewReport";
import ReportDetail from "pages/Reports/ReportDetail";
import { useBoundStore } from "store/store";
import BackupDetail from "pages/BackupPage/BackupDetail";
import MachineDetailPage from "pages/InstandhaltungPage/MachineDetailPage";
import EditMaintenance from "pages/InstandhaltungPage/tabs/Maintenance/EditMaintenance";
import CreateWorkflowStep from "components/CreateWorkflowStep";
import GenericAttachment from "components/GenericAttachments";
import NotificationDetailPage from "pages/NotificationDetailPage/NotificationDetailPage";
import CreateNotification from "components/CreateNotification";
import Profile from "pages/Profile/Profile";
import CreateSite from "pages/Sites/CreateSite";
import CreateEquipment from "pages/Equipments/CreateEquipment";
import SitePage from "pages/Sites/SitePage";
import CreateArea from "pages/Areas/CreateArea";
import Users from "pages/Users/Users";

import AddUser from "pages/Users/AddUser";
import SetPassword from "pages/Users/SetPassword";
import ManualReports from "pages/Reports/ManualReports";
// import { useAutoLogout } from "components/useAutoLogout";
import { useTabCloseLogout } from "hooks/useTabCloseLogout";

function App() {

  // useAutoLogout();       // ⏱️ inactivity logout
  useTabCloseLogout();   // 🚪 tab close / multi-tab sync logout

  const isAdmin = useBoundStore((state) => state.isAdmin);

  const lang: any = useBoundStore((state) => state.lang);
  const setLang: any = useBoundStore((state) => state.setLang);
  const loadTopology: any = useBoundStore((state) => state.loadTopology);

  const isLoggedIn = useBoundStore((state) => state.isLoggedIn);

  // const autoLogout = useBoundStore((state) => state.autoLogout);

  const connectWebMQTT = useBoundStore((state) => state.connectWebMQTT);

  useEffect(() => {
    // --- 1️⃣ Setup language, MQTT, and hydration ---
    if (isLoggedIn === true) {
      connectWebMQTT();
    }

    const localLang = localStorage.getItem("lang");
    if (localLang) {
      setLang(localLang);
      loadTopology(localLang);
    }
  }, []);

  return (
    <div>
      <Router>
        <Routes>
          <Route
            path="*"
            element={
              <div className="pageNotFount">
                <div className="title">{i18n(lang).page_not_found} 404</div>
                <div className="link">
                  <Link to={"/"}> {i18n(lang).back_to_dashboard}</Link>
                </div>
              </div>
            }
          />

          <Route
            path="/login"
            element={
              <AuthRoute type="guest">
                <LoginPage />
              </AuthRoute>
            }
          />
          <Route
            path="/reset-password"
            element={
              <AuthRoute type="guest">
                <ResetPassword />
              </AuthRoute>
            }
          />
          <Route
            path="/two-fa"
            element={
              <AuthRoute type="guest">
                <TwoFa />
              </AuthRoute>
            }
          />
          <Route
            path="/new-password"
            element={
              <AuthRoute type="guest">
                <NewPassword />
              </AuthRoute>
            }
          />

          <Route
            path="/qualitymanagement"
            element={
              <AuthRoute type="private">
                <Layout>
                  <ScopeHeader
                    bgColor="#B21412"
                    bgImage="images/scope_header.png"
                    txtColor="#FFFFFF"
                    title={i18n(lang)?.dashboard_scope_header}
                    description={i18n(lang)?.dashboard_scope_header_desc}
                  />
                  <DashboardPage />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/machine-detail"
            element={
              <AuthRoute type="private">
                <Layout>
                  <MachineDetailPage />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/wartungskalender"
            element={
              <AuthRoute type="private">
                <Layout>
                  <ScopeHeader
                    bgColor="#B21412"
                    bgImage="images/scope_header.png"
                    txtColor="#FFFFFF"
                    title={i18n(lang)?.miantenance_calender_title}
                    description={
                      i18n(lang)?.maintenance_calender_scope_header_desc
                    }
                  />
                  <Wartungskalender />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/reports"
            element={
              <AuthRoute type="private">
                <Layout>
                  <ScopeHeader
                    bgColor="#B21412"
                    bgImage="images/scope_header.png"
                    txtColor="#FFFFFF"
                    title={i18n(lang)?.reportsTitle}
                    description={i18n(lang)?.scope_new_rp_desc}
                  />
                  <Reports />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/manual-reports"
            element={
              <AuthRoute type="private">
                <Layout>
                  <ScopeHeader
                    bgColor="#B21412"
                    bgImage="images/scope_header.png"
                    txtColor="#FFFFFF"
                    title={i18n(lang)?.manualReportsTitle}
                    description={i18n(lang)?.scope_new_mn_rp_desc}
                  />
                  <ManualReports />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/new-report"
            element={
              <AuthRoute type="private">
                <Layout>
                  <NewReport />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/report-detail"
            element={
              <AuthRoute type="private">
                <Layout>
                  <ReportDetail />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/werke"
            element={
              <AuthRoute type="private">
                <Layout>
                  <Werke />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/maintenance"
            element={
              <AuthRoute type="private">
                <Layout>
                  <ScopeHeader
                    bgColor="#B21412"
                    bgImage="images/scope_header.png"
                    txtColor="#FFFFFF"
                    title={i18n(lang)?.dashboard_scope_header}
                    description={i18n(lang)?.dashboard_scope_header_desc}
                  />
                  <Instandhaltung />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-maintenance"
            element={
              <AuthRoute type="private">
                <Layout>
                  <EditMaintenance />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-faq"
            element={
              <AuthRoute type="private">
                <Layout>
                  <GenericAttachment compTitle={i18n(lang)?.add_faq} />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-maintenance"
            element={
              <AuthRoute type="private">
                <Layout>
                  <EditMaintenance />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-notification"
            element={
              <AuthRoute type="private">
                <Layout>
                  <CreateNotification />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/edit-notification"
            element={
              <AuthRoute type="private">
                <Layout>
                  <CreateNotification />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/notification-details"
            element={
              <AuthRoute type="private">
                <Layout>
                  <NotificationDetailPage
                    notiType={6}
                    notification={{ notification: { type: 6 } }}
                  />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/profile"
            element={
              <AuthRoute type="private">
                <Layout>
                  <Profile />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-site"
            element={
              <AuthRoute type="private">
                <Layout>
                  <CreateSite />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-area"
            element={
              <AuthRoute type="private">
                <Layout>
                  <CreateArea />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/sites"
            element={
              <AuthRoute type="private">
                <Layout>
                  <SitePage />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/equipments"
            element={
              <AuthRoute type="private">
                <Layout>
                  <CreateEquipment />
                </Layout>
              </AuthRoute>
            }
          />

          <Route
            path="/create-equipment"
            element={
              <AuthRoute type="private">
                <Layout>
                  <CreateEquipment />
                </Layout>
              </AuthRoute>
            }
          />
          {isAdmin ? (
            <Route
              path="/users"
              element={
                <AuthRoute type="private">
                  <Layout>
                    <Users />
                  </Layout>
                </AuthRoute>
              }
            />
          ) : (
            ""
          )}

          <Route
            path="/add-user"
            element={
              <AuthRoute type="private">
                <Layout>
                  <AddUser />
                </Layout>
              </AuthRoute>
            }
          />

          <Route path="/set-password/:token" element={<SetPassword />} />

          <Route path="/" element={<Navigate to="/login" replace={true} />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
